import { GridRow } from '@/components/ui/layouts/grids/GridRow';
import { Section } from '@/components/ui/layouts/sections/Section';

import { gridRow } from '@mage-ui/styled-system/recipes';
import { Instances } from '../Instances';

export const LeftyCardBlock = ({ data }) => {
  return (
    <Section
      heading={{
        title: data?.fields?.title || null,
        epi: data?.fields?.epi || null,
        meta: data?.fields?.meta_info || null,
        intro: data?.fields?.intro || null,
      }}
    >
      <GridRow
        className={gridRow({
          colGapM: 'gap800',
          colGapL: 'gap900',
        })}
      >
        <Instances instances={data?.relations?.LeftyCardList} />
      </GridRow>
    </Section>
  );
};
